import { z } from 'zod';
import { PartnerNewsActionSchema, PartnerNewsAdminSchema, PartnerNewsAudienceSchema } from '../../entities/partner-news/partner-news.schema';
import { PartnerMaterialTextSchema } from '../../entities/partner-material/partner-material.schema';
/**
 * Update Partner News Request
 * PATCH /api/v2/admin/partner-news/:id
 *
 * For the optional parts, `null` removes them and an absent one keeps them.
 */ export const UpdatePartnerNewsRequestSchema = z.object({
    eyebrow: PartnerMaterialTextSchema.partial().nullable().optional(),
    title: PartnerMaterialTextSchema.optional(),
    body: PartnerMaterialTextSchema.optional(),
    primaryAction: PartnerNewsActionSchema.nullable().optional(),
    secondaryAction: PartnerNewsActionSchema.nullable().optional(),
    footnote: PartnerMaterialTextSchema.partial().nullable().optional(),
    pinned: z.boolean().optional(),
    /** Omitted on create means every partner. */ audience: PartnerNewsAudienceSchema.optional(),
    published: z.boolean().optional()
});
export const UpdatePartnerNewsResponseSchema = z.object({
    data: PartnerNewsAdminSchema
});

//# sourceMappingURL=update-partner-news.schema.js.map